import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-page-style-one',
  templateUrl: './services-page-style-one.component.html',
  styleUrls: ['./services-page-style-one.component.scss']
})
export class ServicesPageStyleOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
